import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

type ExtractionPhase = 'reading' | 'extracting'

type Props = {
  status: 'idle' | 'uploading' | 'done' | 'quota_exceeded' | 'error'
  extractionCount?: number
}

export function ExtractionProgressBar({ status, extractionCount }: Props) {
  const [phase, setPhase] = useState<ExtractionPhase>('reading')

  // Animation séquentielle : phase 1 (0–2s) → "Lecture du document..."
  //                           phase 2 (2s+)  → "Extraction des données..."
  useEffect(() => {
    setPhase('reading')
    if (status !== 'uploading') return
    const timer = setTimeout(() => setPhase('extracting'), 2000)
    return () => clearTimeout(timer)
  }, [status])

  if (status === 'idle') return null

  return (
    <div
      aria-live="polite"
      className="text-sm py-2 px-3 rounded"
    >
      {status === 'uploading' && (
        <span className="text-muted-foreground animate-pulse">
          {phase === 'reading' ? 'Lecture du document...' : 'Extraction des données...'}
        </span>
      )}

      {status === 'done' && (
        <span className={cn('font-medium text-green-700')}>
          ✓ {extractionCount ?? 0} valeur{(extractionCount ?? 0) !== 1 ? 's' : ''} trouvée{(extractionCount ?? 0) !== 1 ? 's' : ''}
        </span>
      )}

      {status === 'error' && (
        <span className="text-red-600">
          Erreur lors de l'extraction
        </span>
      )}
    </div>
  )
}
